<template>
	<div>
		<el-image 
		v-for="(item,index) in ids"
		class="pic"
		:style="{width:`${width}px`,height:`${height}px`}"
		:src="imgUrl2+`${item.id?item.id:item.Id}`" 
		:preview-src-list="imgs">
		</el-image>
	</div>
</template>

<script>
	export default {
		props: {
			imgs: {
				type:Array
			},
			ids:{
				type:Array
			},
			width:{
				type:Number,
				default:100
			},
			height:{
				type:Number,
				default:100
			},
			// id: {
			// 	type: Number,
			// 	default: 0
			// },
		},
		computed: {
			imgUrl2() {
				return this.$store.state.imgUrl2;
			}
		},
		components: {
			
		},
		onLoad(e) {
			
		},
		data() {
			return {
			}
		},
		mounted() {

		},
		methods: {
		}
	}
</script>

<style lang="less" scoped>
	.pic {
		// width: 100px;
		// height: 100px;
		margin-right: 10px;
	}
</style>